import { WarningAmberOutlined } from "@mui/icons-material";
import { Stack, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const expiredYellow = "#eeba0b";

export default function ExpiredChip({ show = false }) {
  const { t } = useTranslation();
  if (!show) {
    return null;
  }
  return (
    <Tooltip title={t("AppointmentNeedsToBeResolved")} arrow>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <WarningAmberOutlined sx={{ color: expiredYellow, fontSize: 16 }} />
        <Typography
          variant="caption"
          sx={{
            color: expiredYellow,
            fontWeight: 500,
            textDecoration: "underline",
          }}
        >
          {t("Expired")}
        </Typography>
      </Stack>
    </Tooltip>
  );
}
